export default {
  '--gray-50': '#f4f5f9',
  '--gray-100': '#e0e1e9',
  '--gray-200': '#c4c7cf',
  '--gray-300': '#a9abb6',
  '--gray-400': '#8a8e9b',
  '--gray-500': '#6c6e79',
  '--gray-600': '#484a54',
  '--gray-700': '#2b2e38',
  '--gray-800': '#191b23',
  '--gray-white': '#ffffff',
  '--blue-50': '#e9f7ff',
  '--blue-100': '#c4e5fe',
  '--blue-200': '#8ecdff',
  '--blue-300': '#2bb3ff',
  '--blue-400': '#008ff8',
  '--blue-500': '#006dca',
  '--blue-600': '#044792',
  '--blue-700': '#002b5f',
  '--blue-800': '#001b3d',
  '--green-50': '#dbfee8',
  '--green-100': '#9ef2c9',
  '--green-200': '#59ddaa',
  '--green-300': '#00c192',
  '--green-400': '#009f81',
  '--green-500': '#007c65',
  '--green-600': '#055345',
  '--green-700': '#00342d',
  '--green-800': '#00201e',
  '--red-50': '#fff0f7',
  '--red-100': '#ffd7df',
  '--red-200': '#ffaeb5',
  '--red-300': '#ff8786',
  '--red-400': '#ff4953',
  '--red-500': '#d1002f',
  '--red-600': '#8e0016',
  '--red-700': '#58000a',
  '--red-800': '#410101',
  '--orange-50': '#fff3d9',
  '--orange-100': '#ffdca2',
  '--orange-200': '#ffb26e',
  '--orange-300': '#ff8c43',
  '--orange-400': '#ff642d',
  '--orange-500': '#c33909',
  '--orange-600': '#8b1500',
  '--orange-700': '#551200',
  '--orange-800': '#351000',
  '--yellow-50': '#fdf7c8',
  '--yellow-100': '#fce081',
  '--yellow-200': '#fdc23c',
  '--yellow-300': '#ef9800',
  '--yellow-400': '#d87900',
  '--yellow-500': '#a75800',
  '--yellow-600': '#743a00',
  '--yellow-700': '#462500',
  '--yellow-800': '#2c1600',
  '--violet-50': '#f9f2ff',
  '--violet-100': '#edd9ff',
  '--violet-200': '#dcb8ff',
  '--violet-300': '#c695ff',
  '--violet-400': '#ab6cfe',
  '--violet-500': '#8649e1',
  '--violet-600': '#5925ab',
  '--violet-700': '#421983',
  '--violet-800': '#220358',
  '--violet-dusty-50': '#F5F4FF',
  '--violet-dusty-100': '#E2DDFF',
  '--violet-dusty-200': '#BCB1E9',
  '--violet-dusty-300': '#A79CD6',
  '--violet-dusty-400': '#9083C5',
  '--violet-dusty-500': '#6D619F',
  '--violet-dusty-600': '#4D407E',
  '--violet-dusty-700': '#382E5E',
  '--violet-dusty-800': '#1D113E',
  '--pink-50': '#fff0ff',
  '--pink-100': '#ffd3ff',
  '--pink-200': '#ffa9fa',
  '--pink-300': '#f67cf2',
  '--pink-400': '#e14adf',
  '--pink-500': '#b229b9',
  '--pink-600': '#7d0480',
  '--pink-700': '#4d0050',
  '--pink-800': '#340439',
  '--salad-50': '#ecfbcd',
  '--salad-100': '#c7ee96',
  '--salad-200': '#9bd85d',
  '--salad-300': '#66c030',
  '--salad-400': '#35a21e',
  '--salad-500': '#0a7e22',
  '--salad-600': '#005613',
  '--salad-700': '#003509',
  '--salad-800': '#002203',
  '--intergalactic-base': 'Inter',
  '--intergalactic-fs-50': '10px',
  '--intergalactic-fs-100': '12px',
  '--intergalactic-fs-200': '14px',
  '--intergalactic-fs-300': '16px',
  '--intergalactic-fs-400': '20px',
  '--intergalactic-fs-500': '24px',
  '--intergalactic-fs-600': '32px',
  '--intergalactic-fs-700': '36px',
  '--intergalactic-fs-800': '48px',
  '--intergalactic-lh-100': '133%',
  '--intergalactic-lh-200': '142%',
  '--intergalactic-lh-300': '150%',
  '--intergalactic-lh-400': '120%',
  '--intergalactic-lh-500': '117%',
  '--intergalactic-lh-600': '125%',
  '--intergalactic-lh-700': '110%',
  '--intergalactic-lh-800': '117%',
  '--intergalactic-semi-bold': '600',
  '--intergalactic-bold': '700',
  '--intergalactic-regular': '400',
  '--intergalactic-medium': '500',
  '--intergalactic-compact': '0.3',
  '--intergalactic-scale-indent': '4px',
  '--intergalactic-spacing-05x': '2px',
  '--intergalactic-spacing-1x': '4px',
  '--intergalactic-spacing-2x': '8px',
  '--intergalactic-spacing-3x': '12px',
  '--intergalactic-spacing-4x': '16px',
  '--intergalactic-spacing-5x': '20px',
  '--intergalactic-spacing-6x': '24px',
  '--intergalactic-spacing-8x': '32px',
  '--intergalactic-spacing-10x': '40px',
  '--intergalactic-spacing-14x': '56px',
  '--intergalactic-spacing-20x': '80px',
  '--intergalactic-spacing-24x': '96px',
  '--intergalactic-spacing-30x': '120px',
  '--intergalactic-rounded-extra-small': '2px',
  '--intergalactic-rounded-small': '4px',
  '--intergalactic-rounded-medium': '6px',
  '--intergalactic-rounded-large': '12px',
  '--intergalactic-rounded-extra-large': '24px',
  '--intergalactic-screen-extra-small': '320px',
  '--intergalactic-screen-small': '768px',
  '--intergalactic-screen-medium': '1200px',
  '--intergalactic-screen-large': '1920px',
  '--intergalactic-duration-extra-slow': '500',
  '--intergalactic-duration-slow': '400',
  '--intergalactic-duration-medium': '300',
  '--intergalactic-duration-fast': '200',
  '--intergalactic-duration-extra-fast': '100',
  '--intergalactic-bg-primary-neutral': 'rgba(30, 34, 49, 1)',
  '--intergalactic-bg-primary-neutral-hover': 'rgba(54, 56, 67, 1)',
  '--intergalactic-bg-primary-neutral-active': 'rgba(54, 56, 67, 1)',
  '--intergalactic-bg-primary-info': '#008ff8',
  '--intergalactic-bg-primary-success': '#009f81',
  '--intergalactic-bg-primary-critical': '#ff4953',
  '--intergalactic-bg-primary-warning': '#ff642d',
  '--intergalactic-bg-primary-highlight': '#fce081',
  '--intergalactic-bg-primary-advertising': '#421983',
  '--intergalactic-bg-primary-muted': '#6c6e79',
  '--intergalactic-bg-primary-invert': '#191b23',
  '--intergalactic-bg-primary-invert-hover': '#2b2e38',
  '--intergalactic-bg-primary-invert-active': '#484a54',
  '--intergalactic-bg-secondary-neutral': 'rgba(45, 48, 62, 1)',
  '--intergalactic-bg-secondary-neutral-hover': '#e0e1e9',
  '--intergalactic-bg-secondary-neutral-active': '#c4c7cf',
  '--intergalactic-bg-secondary-info': 'rgba(52, 68, 90, 1)',
  '--intergalactic-bg-secondary-info-hover': 'rgba(23, 55, 83, 1)',
  '--intergalactic-bg-secondary-info-active': '#8ecdff',
  '--intergalactic-bg-secondary-success': '#dbfee8',
  '--intergalactic-bg-secondary-success-hover': '#9ef2c9',
  '--intergalactic-bg-secondary-success-active': '#59ddaa',
  '--intergalactic-bg-secondary-critical': '#fff0f7',
  '--intergalactic-bg-secondary-critical-hover': '#ffd7df',
  '--intergalactic-bg-secondary-critical-active': '#ffaeb5',
  '--intergalactic-bg-secondary-warning': '#fff3d9',
  '--intergalactic-bg-secondary-warning-hover': '#ffdca2',
  '--intergalactic-bg-secondary-warning-active': '#ffb26e',
  '--intergalactic-bg-secondary-highlight': '#fdf7c8',
  '--intergalactic-bg-secondary-highlight-hover': '#fce081',
  '--intergalactic-bg-secondary-highlight-active': '#fdc23c',
  '--intergalactic-bg-secondary-advertising': 'rgba(75, 49, 125, 1)',
  '--intergalactic-bg-secondary-advertising-hover': '#edd9ff',
  '--intergalactic-bg-secondary-advertising-active': '#dcb8ff',
  '--intergalactic-bg-highlight-results': 'rgba(239, 152, 0, 0.4)',
  '--intergalactic-bg-highlight-focus': 'rgba(0, 143, 248, 0.2)',
  '--intergalactic-text-primary': '#f4f5f9',
  '--intergalactic-text-secondary': '#a9abb6',
  '--intergalactic-text-placeholder': '#8a8e9b',
  '--intergalactic-text-success': 'rgba(68, 209, 164, 1)',
  '--intergalactic-text-success-hover-active': '#055345',
  '--intergalactic-text-critical': 'rgba(255, 155, 148, 1)',
  '--intergalactic-text-critical-hover-active': '#8e0016',
  '--intergalactic-text-primary-invert': '#ffffff',
  '--intergalactic-text-secondary-invert': 'rgba(255, 255, 255, 0.75)',
  '--intergalactic-text-link': '#8ecdff',
  '--intergalactic-text-link-hover-active': '#2bb3ff',
  '--intergalactic-text-link-invert': '#8ecdff',
  '--intergalactic-text-link-invert-hover': '#2bb3ff',
  '--intergalactic-text-link-visited': '#8649e1',
  '--intergalactic-text-hint': '#a9abb6',
  '--intergalactic-text-hint-hover-active': '#e0e1e9',
  '--intergalactic-text-hint-invert': '#c4c7cf',
  '--intergalactic-text-hint-invert-hover-active': '#a9abb6',
  '--intergalactic-text-large-secondary': '#a9abb6',
  '--intergalactic-text-large-info': '#008ff8',
  '--intergalactic-text-large-info-hover-active': '#006dca',
  '--intergalactic-text-large-success': '#009f81',
  '--intergalactic-text-large-success-hover-active': '#007c65',
  '--intergalactic-text-large-critical': '#ff4953',
  '--intergalactic-text-large-critical-hover-active': '#d1002f',
  '--intergalactic-text-advertising': '#421983',
  '--intergalactic-border-primary': '#484a54',
  '--intergalactic-border-secondary': '#484a54',
  '--intergalactic-border-info': '#8ecdff',
  '--intergalactic-border-info-active': '#c4e5fe',
  '--intergalactic-border-success': '#59ddaa',
  '--intergalactic-border-success-active': '#dbfee8',
  '--intergalactic-border-critical': '#ffaeb5',
  '--intergalactic-border-critical-active': 'rgba(253, 182, 177, 1)',
  '--intergalactic-border-warning': '#ffb26e',
  '--intergalactic-border-warning-active': '#c33909',
  '--intergalactic-border-primary-invert': '#ffffff',
  '--intergalactic-border-secondary-invert': 'rgba(255, 255, 255, 0.3)',
  '--intergalactic-border-tooltip-invert': '#6c6e79',
  '--intergalactic-border-table-accent': '#a9abb6',
  '--intergalactic-border-date-picker-range-comparison': '#8649e1',
  '--intergalactic-control-switch-bg': '#a9abb6',
  '--intergalactic-control-primary-info': '#008ff8',
  '--intergalactic-control-primary-info-hover': '#006dca',
  '--intergalactic-control-primary-info-active': '#044792',
  '--intergalactic-control-primary-success': '#009f81',
  '--intergalactic-control-primary-success-hover': '#007c65',
  '--intergalactic-control-primary-success-active': '#055345',
  '--intergalactic-control-primary-critical': '#ff4953',
  '--intergalactic-control-primary-critical-hover': '#d1002f',
  '--intergalactic-control-primary-critical-active': '#8e0016',
  '--intergalactic-control-primary-brand': '#ff642d',
  '--intergalactic-control-primary-brand-hover': '#c33909',
  '--intergalactic-control-primary-brand-active': '#c33909',
  '--intergalactic-control-primary-advertising': '#5925ab',
  '--intergalactic-control-primary-advertising-hover': '#421983',
  '--intergalactic-control-primary-advertising-active': '#8649e1',
  '--intergalactic-control-primary-invert': 'rgba(30, 34, 49, 1)',
  '--intergalactic-control-primary-invert-hover': 'rgba(43, 46, 57, 1)',
  '--intergalactic-control-primary-invert-active': 'rgba(43, 46, 57, 1)',
  '--intergalactic-control-secondary-neutral': 'rgba(138, 142, 155, 0.1)',
  '--intergalactic-control-secondary-neutral-hover': 'rgba(138, 142, 155, 0.2)',
  '--intergalactic-control-secondary-neutral-active': 'rgba(138, 142, 155, 0.3)',
  '--intergalactic-control-secondary-info': 'rgba(0, 143, 248, 0.1)',
  '--intergalactic-control-secondary-info-hover': 'rgba(0, 143, 248, 0.2)',
  '--intergalactic-control-secondary-info-active': 'rgba(0, 143, 248, 0.3)',
  '--intergalactic-control-secondary-invert': 'rgba(255, 255, 255, 0.05)',
  '--intergalactic-control-secondary-invert-hover': 'rgba(255, 255, 255, 0.1)',
  '--intergalactic-control-secondary-invert-active': 'rgba(255, 255, 255, 0.3)',
  '--intergalactic-control-tertiary-neutral': 'rgba(138, 142, 155, 0)',
  '--intergalactic-control-tertiary-neutral-hover': 'rgba(138, 142, 155, 0.2)',
  '--intergalactic-control-tertiary-neutral-active': 'rgba(138, 142, 155, 0.3)',
  '--intergalactic-control-tertiary-info': 'rgba(0, 143, 248, 0)',
  '--intergalactic-control-tertiary-info-hover': 'rgba(0, 143, 248, 0.2)',
  '--intergalactic-control-tertiary-info-active': 'rgba(0, 143, 248, 0.3)',
  '--intergalactic-control-tertiary-invert': 'rgba(255, 255, 255, 0)',
  '--intergalactic-control-tertiary-invert-hover': 'rgba(255, 255, 255, 0.1)',
  '--intergalactic-control-tertiary-invert-active': 'rgba(255, 255, 255, 0.3)',
  '--intergalactic-icon-primary-neutral': '#a9abb6',
  '--intergalactic-icon-primary-neutral-hover-active': '#c4c7cf',
  '--intergalactic-icon-primary-info': '#006dca',
  '--intergalactic-icon-primary-info-hover-active': '#044792',
  '--intergalactic-icon-primary-success': '#009f81',
  '--intergalactic-icon-primary-success-hover-active': '#007c65',
  '--intergalactic-icon-primary-critical': '#ff4953',
  '--intergalactic-icon-primary-critical-hover-active': '#d1002f',
  '--intergalactic-icon-primary-warning': '#ff642d',
  '--intergalactic-icon-primary-warning-hover-active': '#c33909',
  '--intergalactic-icon-primary-invert': '#ffffff',
  '--intergalactic-icon-primary-invert-hover-active': '#e0e1e9',
  '--intergalactic-icon-secondary-neutral': '#c4c7cf',
  '--intergalactic-icon-secondary-neutral-hover-active': '#e0e1e9',
  '--intergalactic-icon-secondary-info': '#2bb3ff',
  '--intergalactic-icon-secondary-info-hover-active': '#008ff8',
  '--intergalactic-icon-secondary-success': '#00c192',
  '--intergalactic-icon-secondary-success-hover-active': '#009f81',
  '--intergalactic-icon-secondary-critical': '#ff8786',
  '--intergalactic-icon-secondary-critical-hover-active': '#ff4953',
  '--intergalactic-icon-secondary-warning': '#ff8c43',
  '--intergalactic-icon-secondary-warning-hover-active': '#ff642d',
  '--intergalactic-icon-non-interactive': '#f4f5f9',
  '--intergalactic-illustration-red': '#FF788F',
  '--intergalactic-illustration-orange': '#FFB26E',
  '--intergalactic-illustration-yellow': '#FFE84D',
  '--intergalactic-illustration-salad': '#C7FA73',
  '--intergalactic-illustration-green': '#45E0A8',
  '--intergalactic-illustration-blue': '#6EDBFF',
  '--intergalactic-illustration-violet': '#B880FF',
  '--intergalactic-illustration-pink': '#FF7AD1',
  '--intergalactic-date-picker-cell': 'rgba(30, 34, 49, 1)',
  '--intergalactic-date-picker-cell-current': '#2b2e38',
  '--intergalactic-date-picker-cell-hover': '#484a54',
  '--intergalactic-date-picker-cell-range': '#002b5f',
  '--intergalactic-date-picker-cell-range-hover': '#044792',
  '--intergalactic-date-picker-cell-active': '#2bb3ff',
  '--intergalactic-date-picker-cell-active-hover': '#008ff8',
  '--intergalactic-date-picker-cell-current-invert': 'rgba(255, 255, 255, 0.5)',
  '--intergalactic-date-picker-cell-comparison-active': '#8649e1',
  '--intergalactic-date-picker-cell-comparison-active-hover': '#5925ab',
  '--intergalactic-dropdown-menu-item': 'rgba(54, 56, 67, 1)',
  '--intergalactic-dropdown-menu-item-hover': 'rgba(79, 82, 93, 1)',
  '--intergalactic-dropdown-menu-item-selected': 'rgba(66, 103, 123, 1)',
  '--intergalactic-dropdown-menu-item-selected-hover': 'rgba(75, 117, 139, 1)',
  '--intergalactic-feature-popover-bg': '#fce081',
  '--intergalactic-feature-popover-dot-outer-border': '#fce081',
  '--intergalactic-feature-popover-bg-neutral': '#1D113E',
  '--intergalactic-feature-popover-dot-neutral': '#00c192',
  '--intergalactic-feature-popover-dot-neutral-outer-border': '#00c192',
  '--intergalactic-progress-bar-bg': '#484a54',
  '--intergalactic-progress-bar-bg-hover': '#c4c7cf',
  '--intergalactic-progress-bar-bg-invert': 'rgba(255, 255, 255, 0.2)',
  '--intergalactic-progress-bar-bg-invert-hover': 'rgba(255, 255, 255, 0.4)',
  '--intergalactic-progress-bar-value-gradient': 'linear-gradient(-45deg, rgba(0, 159, 129, 0.9) 25%, rgba(0, 159, 129, 1) 0%, rgba(0, 159, 129, 1) 50%, rgba(0, 159, 129, 0.9) 0%, rgba(0, 159, 129, 0.9) 75%, rgba(0, 159, 129, 1) 0%)',
  '--intergalactic-progress-bar-pattern-gradient': 'linear-gradient(-45deg, rgba(224, 225, 233, 0.9) 25%, rgba(224, 225, 233, 1) 0%, rgba(224, 225, 233, 1) 50%, rgba(224, 225, 233, 0.9) 0%, rgba(224, 225, 233, 0.9) 75%, rgba(224, 225, 233, 1) 0%)',
  '--intergalactic-progress-bar-value-bg': '#000000',
  '--intergalactic-skeleton-bg': '#484a54',
  '--intergalactic-skeleton-bg-invert': 'rgba(255, 255, 255, 0.3)',
  '--intergalactic-table-th-primary-cell': 'rgba(62, 64, 75, 1)',
  '--intergalactic-table-th-primary-cell-hover': 'rgba(83, 85, 97, 1)',
  '--intergalactic-table-th-primary-cell-active': 'rgba(108, 110, 121, 1)',
  '--intergalactic-table-th-secondary-cell': 'rgba(62, 64, 75, 1)',
  '--intergalactic-table-th-gradient': 'linear-gradient(to right, rgba(224, 225, 233, 0) 0%, rgba(224, 225, 233, 1) 100%)',
  '--intergalactic-table-td-cell': '#191b23',
  '--intergalactic-table-td-cell-hover': '#2b2e38',
  '--intergalactic-table-td-cell-active': '#2b2e38',
  '--intergalactic-table-td-cell-unread': '#f4f5f9',
  '--intergalactic-table-td-cell-accordion': 'rgba(54, 56, 67, 1)',
  '--intergalactic-table-td-cell-selected': 'rgba(43, 54, 69, 1)',
  '--intergalactic-table-td-cell-selected-hover': '#c4e5fe',
  '--intergalactic-table-td-cell-selected-active': '#c4e5fe',
  '--intergalactic-table-td-cell-new': '#dbfee8',
  '--intergalactic-table-td-cell-new-hover': '#9ef2c9',
  '--intergalactic-table-td-cell-new-active': '#9ef2c9',
  '--intergalactic-table-td-cell-critical': '#fff0f7',
  '--intergalactic-table-td-cell-critical-hover': '#ffd7df',
  '--intergalactic-table-td-cell-critical-active': '#ffd7df',
  '--intergalactic-table-td-cell-warning': '#fff3d9',
  '--intergalactic-table-td-cell-warning-hover': '#ffdca2',
  '--intergalactic-table-td-cell-warning-active': '#ffdca2',
  '--intergalactic-brand-primary': '#dcb8ff',
  '--intergalactic-brand-secondary': '#421983',
  '--intergalactic-brand-pinterest': '#bd081c',
  '--intergalactic-brand-instagram': '#e4405f',
  '--intergalactic-brand-youtube': '#ff0000',
  '--intergalactic-brand-facebook': '#1877F2',
  '--intergalactic-brand-linkedIn': '#0A66C2',
  '--intergalactic-brand-twitter': '#1D9BF0',
  '--intergalactic-brand-google-blue': '#1a0dab',
  '--intergalactic-brand-google-green': '#016723',
  '--intergalactic-brand-google-my-business': '#1a73e8',
  '--intergalactic-disabled-opacity': '0.3',
  '--intergalactic-box-shadow-card': '0px 0px 1px 0px rgba(25, 27, 35, 0.16), 0px 1px 2px 0px rgba(25, 27, 35, 0.12)',
  '--intergalactic-box-shadow-card-hover': '3px 3px 30px 0px rgba(25, 27, 35, 0.15)',
  '--intergalactic-box-shadow-dnd': '0px 0px 1px 0px rgba(25, 27, 35, 0.16), 0px 12px 40px 0px rgba(25, 27, 35, 0.16)',
  '--intergalactic-box-shadow-modal': '0px 3px 8px 0px rgba(25, 27, 35, 0.2)',
  '--intergalactic-box-shadow-popper': '0px 1px 15px 0px rgba(25, 27, 35, 0.6)',
  '--intergalactic-keyboard-focus-outline': '#008ff8',
  '--intergalactic-keyboard-focus-invalid-outline': '#ff4953',
  '--intergalactic-keyboard-focus-invalid': '0px 0px 0px 3px rgba(255, 73, 83, 0.5)',
  '--intergalactic-keyboard-focus-valid-outline': '#009f81',
  '--intergalactic-keyboard-focus-valid': '0px 0px 0px 3px rgba(0, 159, 129, 0.5)',
  '--intergalactic-keyboard-focus-invert-outline': 'rgba(255, 255, 255, 0.8)',
  '--intergalactic-keyboard-focus-invert': '0px 0px 0px 3px rgba(255, 255, 255, 0.8)',
  '--intergalactic-keyboard-focus': '0px 0px 0px 3px rgba(0, 143, 248, 0.5)',
  '--intergalactic-form-control-s': '20px',
  '--intergalactic-form-control-m': '28px',
  '--intergalactic-form-control-l': '40px',
  '--intergalactic-addon-rounded': '4px',
  '--intergalactic-badge-rounded': '6px',
  '--intergalactic-chart-rounded': '2px',
  '--intergalactic-counter-rounded': '12px',
  '--intergalactic-tag-rounded': '24px',
  '--intergalactic-switch-rounded': '24px',
  '--intergalactic-control-rounded': '6px',
  '--intergalactic-progress-bar-rounded': '6px',
  '--intergalactic-surface-rounded': '6px',
  '--intergalactic-popper-rounded': '6px',
  '--intergalactic-modal-rounded': '12px',
  '--intergalactic-overlay-primary': 'rgba(25, 27, 35, 0.7)',
  '--intergalactic-overlay-secondary': 'rgba(25, 27, 35, 0.4)',
  '--intergalactic-overlay-limitation-primary': '#f4f5f9',
  '--intergalactic-overlay-limitation-secondary': 'rgba(255, 255, 255, 0.85)',
  '--intergalactic-tooltip-default': '#484a54',
  '--intergalactic-tooltip-warning': 'rgba(160, 13, 42, 1)',
  '--intergalactic-tooltip-invert': '#191b23',
  '--intergalactic-neighbor-location-neutral': 'rgba(255, 255, 255, 0.5)',
  '--intergalactic-neighbor-location-invert': 'rgba(0, 0, 0, 0.5)',
  '--intergalactic-scroll-area-shadow-left': 'linear-gradient(to right, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%)',
  '--intergalactic-scroll-area-shadow-right': 'linear-gradient(to left, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%)',
  '--intergalactic-scroll-area-shadow-top': 'linear-gradient(to bottom, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%)',
  '--intergalactic-scroll-area-shadow-bottom': 'linear-gradient(to top, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%)',
  '--intergalactic-scroll-area-dropdown-menu-left': 'linear-gradient(to right, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)',
  '--intergalactic-scroll-area-dropdown-menu-right': 'linear-gradient(to left, rgba(255, 255, 255, 1) 34.38%, rgba(255, 255, 255, 0) 100%)',
  '--intergalactic-scroll-area-dropdown-menu-bottom': 'linear-gradient(to top, rgba(43, 46, 56, 1) 34.38%, rgba(54, 56, 67, 0) 100%)',
  '--intergalactic-scroll-area-dropdown-menu-top': 'linear-gradient(to bottom, rgba(43, 46, 56, 1) 34.38%, rgba(54, 56, 67, 0) 100%)',
  '--intergalactic-scroll-bar-background': 'rgba(25, 27, 35, 0.3)',
  '--intergalactic-tag-primary-gray-normal': 'rgba(69, 70, 81, 1)',
  '--intergalactic-tag-primary-gray-hover-active': '#e0e1e9',
  '--intergalactic-tag-primary-blue-normal': 'rgba(7, 77, 141, 1)',
  '--intergalactic-tag-primary-blue-hover-active': '#c4e5fe',
  '--intergalactic-tag-primary-green-normal': 'rgba(9, 99, 82, 1)',
  '--intergalactic-tag-primary-green-hover-active': '#9ef2c9',
  '--intergalactic-tag-primary-orange-normal': 'rgba(156, 49, 11, 1)',
  '--intergalactic-tag-primary-orange-hover-active': '#ffdca2',
  '--intergalactic-tag-primary-red-normal': 'rgba(160, 13, 42, 1)',
  '--intergalactic-tag-primary-red-hover-active': '#ffd7df',
  '--intergalactic-tag-primary-violet-normal': 'rgba(95, 62, 157, 1)',
  '--intergalactic-tag-primary-violet-hover-active': '#edd9ff',
  '--intergalactic-tag-primary-yellow-normal': 'rgba(252, 224, 129, 0.5)',
  '--intergalactic-tag-primary-yellow-hover-active': '#fce081',
  '--intergalactic-tag-primary-white-normal': 'rgba(255, 255, 255, 0.15)',
  '--intergalactic-tag-primary-white-hover-active': 'rgba(255, 255, 255, 0.3)',
  '--intergalactic-tag-primary-gray-text': '#f4f5f9',
  '--intergalactic-tag-primary-blue-text': '#e9f7ff',
  '--intergalactic-tag-primary-green-text': '#dbfee8',
  '--intergalactic-tag-primary-orange-text': '#fff3d9',
  '--intergalactic-tag-primary-red-text': '#fff0f7',
  '--intergalactic-tag-primary-violet-text': 'rgba(244, 245, 249, 1)',
  '--intergalactic-tag-primary-yellow-text': '#a75800',
  '--intergalactic-tag-primary-white-text': '#ffffff',
  '--intergalactic-tag-secondary-normal': '#ffffff',
  '--intergalactic-tag-secondary-hover-active': '#f4f5f9',
  '--intergalactic-tag-secondary-white-normal': 'rgba(255, 255, 255, 0)',
  '--intergalactic-tag-secondary-white-hover-active': 'rgba(255, 255, 255, 0.1)',
  '--intergalactic-tag-secondary-gray-text': '#6c6e79',
  '--intergalactic-tag-secondary-white-text': '#ffffff',
  '--intergalactic-chart-palette-order-1': '#2bb3ff',
  '--intergalactic-chart-palette-order-2': '#59ddaa',
  '--intergalactic-chart-palette-order-3': '#ff642d',
  '--intergalactic-chart-palette-order-4': '#f67cf2',
  '--intergalactic-chart-palette-order-5': '#fdc23c',
  '--intergalactic-chart-palette-order-6': '#ab6cfe',
  '--intergalactic-chart-palette-order-7': '#ff8786',
  '--intergalactic-chart-palette-order-8': '#9bd85d',
  '--intergalactic-chart-palette-order-9': '#008ff8',
  '--intergalactic-chart-palette-order-10': '#00c192',
  '--intergalactic-chart-palette-order-11': '#ffb26e',
  '--intergalactic-chart-palette-order-12': '#e14adf',
  '--intergalactic-chart-palette-order-13': '#ef9800',
  '--intergalactic-chart-palette-order-14': '#dcb8ff',
  '--intergalactic-chart-palette-order-15': '#ff4953',
  '--intergalactic-chart-palette-order-16': '#66c030',
  '--intergalactic-chart-palette-order-17': '#8ecdff',
  '--intergalactic-chart-palette-order-18': '#009f81',
  '--intergalactic-chart-palette-order-19': '#ff8c43',
  '--intergalactic-chart-palette-order-20': '#ffa9fa',
  '--intergalactic-chart-palette-order-21': '#d87900',
  '--intergalactic-chart-palette-order-22': '#c695ff',
  '--intergalactic-chart-palette-order-23': '#ffaeb5',
  '--intergalactic-chart-palette-order-24': '#35a21e',
  '--intergalactic-chart-palette-order-total-amount': '#8a8e9b',
  '--intergalactic-chart-palette-order-other-data': '#c4c7cf',
  '--intergalactic-chart-palette-order-null': '#e0e1e9',
  '--intergalactic-chart-grid-line': '#e0e1e9',
  '--intergalactic-chart-grid-x-axis': '#c4c7cf',
  '--intergalactic-chart-grid-y-accent-hover-line': '#a9abb6',
  '--intergalactic-chart-grid-text-label': '#6c6e79',
  '--intergalactic-chart-grid-bar-chart-hover': 'rgba(196, 199, 207, 0.3)',
  '--intergalactic-chart-grid-bar-chart-base-bg': '#e0e1e9',
  '--intergalactic-chart-grid-period-bg': 'rgba(196, 199, 207, 0.2)',
  '--intergalactic-chart-grid-period-pattern': 'rgba(25, 27, 35, 0.15)',
  '--intergalactic-chart-grid-border': '#191b23',
  '--intergalactic-chart-x-axis-accent-period-active': '#8a8e9b',
  '--intergalactic-chart-x-axis-accent-data-start-tracking': 'rgba(0, 159, 129, 0.2)',
  '--intergalactic-header-bg': '#382E5E',
  '--intergalactic-header-border-primary': '#382E5E',
  '--intergalactic-header-border-secondary': 'rgba(255,255,255, 0.15)',
  '--intergalactic-sidebar-nav-control-hover': 'rgba(224, 225, 233, 0.7)',
  '--intergalactic-sidebar-nav-control-active': '#E2DDFF',
  '--intergalactic-sidebar-nav-control-text-normal': '#6D619F',
  '--intergalactic-sidebar-nav-control-text-active': '#4D407E',
  '--intergalactic-sidebar-nav-control-icon-normal': '#9083C5',
  '--intergalactic-sidebar-nav-control-icon-active': '#4D407E',
  '--intergalactic-z-index-deep': '-999',
  '--intergalactic-z-index-overlay': '500',
  '--intergalactic-z-index-modal': '900',
  '--intergalactic-z-index-popper': '700',
  '--intergalactic-z-index-dropdown': '750',
  '--intergalactic-z-index-tooltip': '800',
  '--intergalactic-z-index-notice-bubble': '999',
  '--intergalactic-duration-switch': '100',
  '--intergalactic-duration-popper': '200',
  '--intergalactic-duration-control': '200',
  '--intergalactic-duration-modal': '200',
  '--intergalactic-duration-accordion': '200',
  '--intergalactic-duration-counter': '200',
};
